export default "__VITE_ASSET__e38728c2__"